// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"12d2d2a4","588":"72328d9b","787":"e3ec54b2"}[chunkId] + ".chunk.js";
};